








































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { FiservDebitCardInfo, BootstrapVueRowDetails, FiservDebitCardStatus } from "@/shared/types";
import { useNotifierStore } from "@/shared/store/notifier";
import { useFiservDebitCardsStore } from "@/shared/store/fiservDebitCards";

@Component({
  components: {}
})
export default class FiservDebitCardReplacementForm extends Vue {

  notifierStore = useNotifierStore();
  fiservDebitCardStore = useFiservDebitCardsStore();

  FiservDebitCardStatus = FiservDebitCardStatus;

  @Prop()
  row: BootstrapVueRowDetails;

  @Prop()
  card: FiservDebitCardInfo;

  onSubmitChanges (e: Event) {
    e.preventDefault();

    this.fiservDebitCardStore.replaceFiservDebitCard(this.card.fiservUserInfoId)
      .then(() => {
        this.notifierStore.setSuccess(
          `Replacement for card with last four digits "${this.card.cardNumberLast4}" ordered. A new card will be sent to you shortly.`);
        this.row.toggleDetails();
      }).catch(() => {
        this.notifierStore.setDanger(
          `There was an error requesting a new card with our provider. Please wait and try again later.`);
      });
  }

}
